export default __webpack_public_path__ + "static/media/skyscraper.d765e7e5.png";